import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { CreditRequestDetailComponent } from './credit-request-detail-component';
import { StackScreenProps } from '@react-navigation/stack';

export type Props = StackScreenProps<
  AppContainerStackParams,
  APP_CONTAINER_ROUTES.CreditRequestDetail
>;

export const CreditRequestDetailScreen: React.FC<Props> = ({ route }) => {
  const { creditRequestBatchUUID } = route.params;

  return (
    <CreditRequestDetailComponent
      creditRequestBatchUUID={creditRequestBatchUUID}
    />
  );
};
